import React, {useState}				from 'react';

import {ButtonGroupProps}				from './interface';

import './ButtonGroup.css';

const defaultProps: ButtonGroupProps = {
	data:    [],
	type:    'primary',
	onClick: () => null
};


function	ButtonGroup(props: ButtonGroupProps) {
	props = {...defaultProps, ...props};

	const [isFocused, set_isFocused] = useState(-1);

	const handleKeyDown = (event: React.KeyboardEvent<HTMLDivElement>, i: number, value: string) => {
		if (event.key === 'Enter' && isFocused === i)
			props.onClick(value);
	};

	const render: React.ReactElement[] = [];

	if (props.data) {
		props.data.forEach((data, i) => {
			let className = 'buttonGroupItem';

			if (props.actual === data.value)
				className += ` ${props.type}-600-border ${props.type}-200-background`;
			else
				className += ` ${props.type}-200-border`;

			render.push(
				<div
					tabIndex={0}
					role={'button'}
					className={className}
					key={`button-group-${i}`}
					onFocus={() => set_isFocused(i)}
					onBlur={() => set_isFocused(-1)}
					onClick={() => props.onClick(data.value)}
					onKeyDown={event => handleKeyDown(event, i, data.value)}
					style={{
						...props.styleItem,
						...(props.actual === data.value && {borderRight: '1px solid'}),
						...(props.actual === props.data[i - 1]?.value && {borderLeft: 'unset'})
					}}
				>
					{data.render}
				</div>
			);
		});
	}

	return (
		<div className={'buttonGroup'} style={props.style}>
			{render}
		</div>
	);
}

export default ButtonGroup;
